import React from "react";
import "../../App.css";
import LrMasterForm from "../LrMasterForm";

function LrMasterPage({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("lr_master")){
    return;
  }
  return (
    <div className="page-vehicle">
      <LrMasterForm sessionObject={sessionObject} />
    </div>
  );
}

export default LrMasterPage;